import * as React from 'react';
const SvgNoApplications = (props) => (
  <svg
    width={140}
    height={143}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M71.5016 125.95C104.302 125.95 130.902 99.5496 130.902 66.9496C130.902 34.3496 104.302 7.94958 71.5016 7.94958C38.7016 7.94958 12.1016 34.3496 12.1016 66.9496C12.1016 99.5496 38.7016 125.95 71.5016 125.95Z"
      fill="#EAEEF9"
    />
    <path
      d="M117.002 59.2495V95.3495C117.002 102.85 110.902 108.95 103.302 108.95H39.9017C32.4017 108.95 26.3017 102.95 26.2017 95.4495C26.2017 95.3495 26.2017 95.3495 26.2017 95.2495V59.2495C26.2017 59.1495 26.2017 59.1495 26.2017 59.0495C26.2017 58.8495 26.2017 58.6495 26.3017 58.4495C26.4017 58.1495 26.5017 57.9495 26.6017 57.6495L43.6017 25.1495C44.2017 23.8495 45.5017 23.1495 46.9017 23.1495H96.2017C97.6017 23.1495 98.8017 23.8495 99.5017 25.1495L116.502 57.6495C116.602 57.8495 116.702 58.1495 116.802 58.4495C117.002 58.6495 117.002 58.9495 117.002 59.2495Z"
      fill="#D5DDEA"
    />
    <g filter="url(#filter0_d_1265_3728)">
      <path
        d="M117.002 59.2496V99.0496C117.002 104.55 112.602 108.95 107.002 108.95H36.2017C30.7017 108.95 26.2017 104.55 26.2017 99.0496V59.0496C26.2017 58.8496 26.2017 58.6496 26.3017 58.4496H49.1017C52.5017 58.4496 55.3017 61.1496 55.3017 64.6496C55.3017 66.3496 56.0017 67.9496 57.1017 69.0496C58.3017 70.2496 59.7017 70.8496 61.5017 70.8496H81.8017C85.2017 70.8496 88.0017 68.1496 88.0017 64.6496C88.0017 62.9496 88.7017 61.3496 89.8017 60.2496C91.0017 59.0496 92.4017 58.4496 94.1017 58.4496H116.802C117.002 58.6496 117.002 58.9496 117.002 59.2496Z"
        fill="url(#paint0_linear_1265_3728)"
      />
    </g>
    <path
      d="M129.384 38.7496C131.648 38.7496 133.484 36.9139 133.484 34.6496C133.484 32.3852 131.648 30.5496 129.384 30.5496C127.119 30.5496 125.284 32.3852 125.284 34.6496C125.284 36.9139 127.119 38.7496 129.384 38.7496Z"
      fill="#EAEEF9"
    />
    <path
      d="M125.284 25.4496C126.83 25.4496 128.084 24.196 128.084 22.6496C128.084 21.1032 126.83 19.8496 125.284 19.8496C123.737 19.8496 122.484 21.1032 122.484 22.6496C122.484 24.196 123.737 25.4496 125.284 25.4496Z"
      fill="#EAEEF9"
    />
    <path
      d="M11.8837 34.6496C13.4301 34.6496 14.6837 33.396 14.6837 31.8496C14.6837 30.3032 13.4301 29.0496 11.8837 29.0496C10.3373 29.0496 9.08374 30.3032 9.08374 31.8496C9.08374 33.396 10.3373 34.6496 11.8837 34.6496Z"
      fill="#EAEEF9"
    />
    <path
      d="M5.58379 96.2496C8.45567 96.2496 10.7838 93.9215 10.7838 91.0496C10.7838 88.1777 8.45567 85.8496 5.58379 85.8496C2.71191 85.8496 0.383789 88.1777 0.383789 91.0496C0.383789 93.9215 2.71191 96.2496 5.58379 96.2496Z"
      fill="#EAEEF9"
    />
    <path
      d="M96.6216 11.1187C97.9267 25.3658 98.5792 28.6285 95.6244 41.5313C94.6635 44.3998 93.7026 47.5416 91.6435 49.7271C88.7607 53.142 83.5443 54.6446 79.2889 53.5518C74.8961 52.4591 71.327 48.6343 70.5033 43.99C69.817 41.1215 70.7779 37.7065 73.2488 35.9308C75.857 34.2916 79.5634 34.7014 81.7598 36.7504C84.2307 38.7993 85.1916 41.9411 85.0543 44.9462C84.9171 47.9513 83.8189 50.9565 82.3089 53.5518C78.8954 59.9335 77.4901 59.91 70.5034 70.3911"
      stroke="#ABB5CC"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeDasharray="4 4"
    />
    <path
      d="M104.275 5.81244C103.753 7.71624 101.666 8.40853 99.579 7.19702C97.3179 6.15858 95.7525 5.29322 96.1004 3.56249C96.6222 1.83177 98.7093 1.65869 101.144 1.48562C104.101 1.13948 104.623 3.90864 104.275 5.81244Z"
      fill="#DAE2EB"
    />
    <path
      d="M87.4039 7.54302C88.2736 9.10068 90.7086 10.1391 92.4479 8.58146C94.3611 6.85073 95.9264 5.63922 95.0568 3.9085C94.1872 2.35084 92.7957 2.87006 89.8389 3.21621C87.4039 3.73542 86.3604 5.8123 87.4039 7.54302Z"
      fill="#DAE2EB"
    />
    <path
      d="M95.0569 1.13954C96.2744 0.966469 97.4919 1.65876 97.8397 2.6972C98.0137 3.04334 98.1876 3.56256 98.1876 3.9087C98.5355 6.33172 97.6658 8.40859 96.2744 8.58167C94.709 8.92781 93.1437 7.19708 92.9697 4.94714C92.9697 4.25485 92.9697 3.9087 92.9697 3.38949C93.1437 2.17798 93.8394 1.31262 95.0569 1.13954Z"
      fill="#989FB0"
    />
    <defs>
      <filter
        id="filter0_d_1265_3728"
        x={4.20166}
        y={47.4496}
        width={134.8}
        height={94.5004}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1265_3728"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1265_3728"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1265_3728"
        x1={71.5721}
        y1={57.2815}
        x2={71.5721}
        y2={109.494}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgNoApplications;
